<div class="modal-header">
  <h4 class="modal-title">
    {{ pageTitle }}
  </h4>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss('')"
  >
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label for="">Priority</label>
        <select
          name="priority"
          id="priority"
          class="form-control"
          [(ngModel)]="formData.design_priority"
        >
          <option value=""></option>
          <option value="10">Low</option>
          <option value="20">Medium</option>
          <option value="30">High</option>
        </select>
      </div>

      <div class="form-group">
        <label>Project Type</label>
        <ng-select
          [items]="projectTypes"
          bindValue="id"
          bindLabel="name"
          [loading]="projectTypeSvc.gettingRecords"
          [(ngModel)]="formData.project_type_id"
          [multiple]="false"
          (change)="checkDateIfValid()"
        >
        </ng-select>
        <div class="pt-1 text-danger" *ngIf="formData.project_type_id">
          <i
            >Estimated due date
            {{ updateEstimatedDueDate() | date: 'shortDate' }}</i
          >
        </div>
      </div>
    </div>

    <div class="col-md-6">
      <div class="form-group">
        <label>Tags</label>
        <ng-select
          [items]="tags"
          bindValue="id"
          [(ngModel)]="formData.assigned_tags"
          [searchFn]="customTagsSearchFn"
          multiple="true"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
            <span [innerHTML]="item.name" class="d-inline"></span>
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <h6 [innerHTML]="item.name"></h6>
          </ng-template>
        </ng-select>
      </div>

      <div class="form-group">
        <label for="">Due Date</label>
        <input
          type="date"
          [(ngModel)]="formData.due_date"
          class="form-control"
          [ngStyle]="{ 'border-color': invalidDueDate ? 'red' : '#e2e5ec' }"
          (change)="checkDateIfValid()"
        />
        <div class="pt-1 text-danger" *ngIf="invalidDueDate">
          <i>Warning! Due date is BEFORE the projected leadtime due date. </i>
        </div>
      </div>

      <!-- 					<div class="form-group">
						<label for="">Assign To</label>
						<ng-select [items]="staffSvc.staff$ | async" [multiple]="true" [closeOnSelect]="true"
							bindLabel="firstname" bindValue="id" [searchable]="true" [(ngModel)]="formData.assigned_users"
							[hideSelected]="true">
							<ng-template ng-label-tmp let-item="item" let-clear="clear">
								<span class="ng-value-label">
									{{item.firstname}} {{item.lastname}}
								</span>
								<span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
							</ng-template>
							<ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
								<div>
									{{item.firstname}} {{item.lastname}}
								</div>
							</ng-template>
						</ng-select>
					</div> -->
    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label for="">Category</label>
        <select
          class="form-control"
          [(ngModel)]="formData.category_id"
          (change)="getSubCategories()"
        >
          <option
            [value]="bt.id"
            *ngFor="let bt of productCategoriesSvc._productCategories | async"
          >
            {{ bt.product_category }}
          </option>
        </select>
      </div>
    </div>
    <div class="col-md-6">
      <div
        class="form-group"
        *ngIf="selectedCategory && selectedCategory.sub_categories"
      >
        <label for="">Sub Category</label>
        <select class="form-control" [(ngModel)]="formData.subcategory_id">
          <option
            *ngFor="let bt of selectedCategory.sub_categories"
            [value]="bt.id"
          >
            {{ bt.sub_category }}
          </option>
        </select>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12">
      <div class="form-group">
        <label for="">Assign To</label>
        <ng-select
          [items]="staffSvc.assignee$ | async"
          [multiple]="true"
          [closeOnSelect]="true"
          bindLabel="firstname"
          bindValue="id"
          [searchable]="true"
          [(ngModel)]="formData.assigned_users"
          [hideSelected]="true"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span class="ng-value-label">
              {{ item.firstname }} {{ item.lastname }}
            </span>
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <div>{{ item.firstname }} {{ item.lastname }}</div>
          </ng-template>
        </ng-select>
      </div>
    </div>
  </div>

  <div class="mb-3">
    <h6 class="product my-2">
      Set Pipelines
      <button class="btn btn-secondary btn-sm" type="button" (click)="addPipeline()"
        ><i class="fas fa-plus"></i> Add Pipeline</button
      >
    </h6>

    <table
      class="table table-striped"
      *ngIf="designPipelines && designPipelines.length > 0"
    >
      <thead>
        <tr>
          <th>Pipeline</th>
          <th>Stage</th>
          <!-- <th>Priority</th> -->
          <th>&nbsp;</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let rp of designPipelines; let i = index">
          <td>
            <select
              class="form-control"
              name="{{ 'pipeline' + i.toString() }}"
              [(ngModel)]="rp.pipeline_id"
              (change)="setStages(i)"
            >
              <option *ngFor="let p of pipelines" [value]="p.id">{{
                p.label
              }}</option>
            </select>
          </td>
          <td>
            <select
              class="form-control"
              name="{{ 'stage' + i.toString() }}"
              [(ngModel)]="rp.pipeline_stage_id"
            >
              <option *ngFor="let s of rp.stages" [value]="s.id">{{
                s.stage
              }}</option>
            </select>
          </td>
          <!-- <td>
						<select class="form-control" name="{{ 'priority' + i.toString() }}" [(ngModel)]="rp.priority">
							<option *ngFor="let s of pipelineSvc.priorities" [value]="s.id">{{ s.label }}</option>
						</select>
					</td> -->
          <td valign="middle">
            <a href="javascript:;" (click)="designPipelines.splice(i, 1)">
              <i class="fas fa-times text-danger"></i>
            </a>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <mat-tab-group>
    <mat-tab label="Desciption">
      <div class="row">
        <div class="col-md-12">
          <mat-tab-group [(selectedIndex)]="activeDescriptionTab">
            <mat-tab>
              <ng-template mat-tab-label> Design Description </ng-template>
              <div class="form-group">
                <!-- <textarea class="form-control" rows="7" [(ngModel)]="formData.description" required></textarea> -->
                <angular-editor
                  name="product_description"
                  [(ngModel)]="formData.description"
                  required
                >
                </angular-editor>
              </div>
            </mat-tab>
            <mat-tab
              *ngFor="
                let description of formData.additional_descriptions;
                let i = index
              "
            >
              <ng-template mat-tab-label>
                <input
                  *ngIf="activeDescriptionTab - 1 == i"
                  type="text"
                  class="form-control"
                  [(ngModel)]="formData.additional_descriptions[i].title"
                  (keydown)="handleDescriptionInput($event)"
                />
                <ng-container *ngIf="activeDescriptionTab - 1 != i">{{
                  formData.additional_descriptions[i].title
                }}</ng-container>
                <button
                  *ngIf="activeDescriptionTab - 1 == i"
                  mat-icon-button
                  (click)="removeDescription(i)"
                  class="text-danger"
                >
                  <mat-icon>close</mat-icon>
                </button>
              </ng-template>
              <div class="form-group">
                <!-- <textarea class="form-control" rows="7" [(ngModel)]="formData.description" required></textarea> -->
                <angular-editor
                  name="product_description"
                  [(ngModel)]="formData.additional_descriptions[i].text"
                  required
                >
                </angular-editor>
              </div>
            </mat-tab>
            <mat-tab disabled>
              <ng-template mat-tab-label>
                <button mat-icon-button (click)="addDescription()"
                  ><mat-icon>add_circle</mat-icon> Add New</button
                >
              </ng-template>
            </mat-tab>
          </mat-tab-group>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Links">
      <div class="row">
        <div class="col-md-12">
          <div class="form-group links">
            <label>Links</label>
            <div class="input-group mb-3">
              <input
                type="text"
                class="form-control"
                [(ngModel)]="link"
                (keyup.enter)="addLink(link); link = ''"
                placeholder="Add link"
                aria-label="Add link"
              />
              <div class="input-group-append">
                <button
                  class="btn btn-outline-secondary"
                  (click)="addLink(link); link = ''"
                  type="button"
                  ><i class="fas fa-plus"></i> Add</button
                >
              </div>
            </div>
            <span
              class="badge badge-primary m-1"
              *ngFor="let link of linksToUpload; let i = index"
            >
              {{ link }}
              <a
                href="javascript:;"
                class="text-danger"
                title="Remove"
                (click)="linksToUpload.splice(i, 1)"
              >
                <i class="fas fa-times"></i>
              </a>
            </span>
          </div>
        </div>
      </div>

      <!-- <fieldset>
				<div class="form-group">
					<label>Attachments</label>
					<div class="form-group mb-0">
						<input type="file" class="form-control" id="files" multiple (change)="handleFileInput($event)" />
					</div>
				</div>
				<span class="badge badge-primary m-1" *ngFor="let file of filesToUpload; let i = index">
					{{ file.file.name }}
					<a href="javascript:;" class="text-danger" title="Remove" (click)="filesToUpload.splice(i, 1)">
						<i class="fas fa-times"></i>
					</a>
				</span>

				<div class="form-group" *ngIf="formData.attachments && formData.attachments.length > 0">
					<ul class="list-group" *ngFor="let file of formData.attachments; let i = index">
						<li class="list-group-item d-flex justify-content-between align-items-center">
							<div class="row">
								<div class="col-md-12"><i class="fa fa-file text-info mr-4 fa-2x"></i>{{ file.name }}</div>
							</div>
							<div class="row">
								<div class="col-md-12">
									<button (click)="formData.attachments.splice(i, 1)" class="btn btn-sm btn-link"><i class="fas fa-times"></i></button>
								</div>
							</div>
						</li>
					</ul>
				</div>
			</fieldset> -->
    </mat-tab>
    <mat-tab label="Static Tags" *ngIf="staticTags && staticTags.length > 0">
      <div class="form-group" *ngFor="let tag of staticTags">
        <label for="">{{ tag.name }}</label>
        <ng-select
          [items]="tag.children"
          bindValue="id"
          appendTo="body"
          [(ngModel)]="tag.selectedValues"
          [searchFn]="customTagsSearchFn"
          multiple="true"
        >
          <ng-template ng-label-tmp let-item="item" let-clear="clear">
            <span
              class="ng-value-icon right"
              (click)="clear(item)"
              aria-hidden="true"
              >×</span
            >
            <span [innerHTML]="item.name" class="d-inline"></span>
          </ng-template>
          <ng-template
            ng-option-tmp
            let-item="item"
            let-index="index"
            let-search="searchTerm"
          >
            <h6 [innerHTML]="item.name"></h6>
          </ng-template>
        </ng-select>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-outline-secondary"
    (click)="activeModal.dismiss('')"
    [translate]="'BUTTONS.CLOSE'"
    ><i class="fas fa-times"></i> Close</button
  >
  <button
    type="button"
    class="btn btn-primary"
    [ngClass]="{
      'kt-spinner kt-spinner--right kt-spinner--md kt-spinner--light': loading,
    }"
    [disabled]="loading"
    (click)="saveDesign()"
  >
    <i class="fas fa-save"></i> Save Task
  </button>
</div>
